import { Component, OnInit } from "@angular/core";
import { NgForm } from "@angular/forms";
import { OrderService } from "../service/order.service";
import { ItemService } from "../service/item.service";
import { Supplier } from "../model/supplier"; // added
import { OrderDetails } from "../model/orderDetails";
import { SupplierManagementService } from "../service/supplier-management.service";

@Component({
  selector: "app-new-order",
  templateUrl: "./new-order.component.html",
  styleUrls: ["./new-order.component.css"],
})
export class NewOrderComponent implements OnInit {
  orderDetails: OrderDetails;

  price: number;
  quantity: number;
  totalSum: number = 0;

  todayDate: Date;

  itemsList: any[] = [];

  suppliers: Supplier[] = []; // all suppliers
  filteredSuppliers: Supplier[] = []; // suggestions for autocomplete
  selectedSupplier: Supplier | null = null; // bound to p-autoComplete

  constructor(
    private orderService: OrderService,
    private itemService: ItemService,
    private supplierService: SupplierManagementService
  ) {}

  ngOnInit() {
    this.todayDate = new Date();
    this.getAllSuppliers();

    this.itemService.getItemList().subscribe(
      (response: string[]) => {
        console.log(response);

        // Convert string array into PrimeNG dropdown format
        this.itemsList = response.map((itemName) => ({
          label: itemName,
          value: itemName,
        }));
      },
      (error) => {}
    );
  }

  getAllSuppliers = () => {
    this.supplierService.getSuppliers().subscribe(
      (response: Supplier[]) => {
        // Only active suppliers
        this.suppliers = response.filter((s) => s.Active);
        // Optionally pre-populate the first 50 for performance
        this.filteredSuppliers = this.suppliers.slice(0, 50);
      },
      (error) => console.log(error)
    );
  };

  // Called by p-autoComplete when user types
  searchSuppliers(event: { query: string }) {
    const term = (event.query || "").toLowerCase().trim();
    if (!term) {
      this.filteredSuppliers = this.suppliers.slice(0, 50);
    } else {
      this.filteredSuppliers = this.suppliers
        .filter((s) => (s.Name || "").toLowerCase().includes(term))
        .slice(0, 50);
    }
  }

  supplierSelected(event: any) {
    // event is the supplier object
    console.log("Selected supplier:", event);
  }

  calculateTotal() {
    this.totalSum = this.price * this.quantity;
  }

  submitForm = (form: NgForm) => {
    if (form.invalid) return;

    // require a selected supplier
    if (!this.selectedSupplier) {
      alert("בחר ספק לפני שליחת ההזמנה");
      return;
    }

    this.orderDetails = form.value;
    // set supplier id from selected supplier object
    this.orderDetails.SupplierId = this.selectedSupplier.Id;
    this.orderDetails.CustomerId = 2;
    this.orderDetails.TotalPrice = this.totalSum;

    console.log(this.orderDetails);

    this.orderService.createNewOrder(this.orderDetails).subscribe(
      (response) => {
        console.log(response);
        alert("ההזמנה נירשמה בהצלחה!");
      },
      (error) => {
        console.log(error);
        alert("שגיאה, משהו השתבש בבקשה דווח על התקלה");
      }
    );
  };
}



// WEBPACK FOOTER //
// C:/MyProjects_Git/GoDocu/GoDocuMng/Client/src/app/new-order/new-order.component.ts